import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import usePocketBaseAuth from "../hooks/Auth/usePocketBaseAuth";
import Sidebar from "../components/Widgets/Global/Sidebar";
import { FaBars } from "react-icons/fa";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = usePocketBaseAuth();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isMobileSidebarOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileSidebarOpen]);

  return isAuthenticated ? (
    <div className="flex min-h-screen flex-col bg-gray-100 md:h-screen">
      <div className="sticky top-0 z-30 flex items-center justify-between border-b border-gray-200 bg-white px-4 py-3 shadow-sm md:hidden">
        <button
          type="button"
          onClick={() => setIsMobileSidebarOpen(true)}
          className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-gray-200 text-gray-700 transition hover:bg-gray-50"
          aria-label="Open navigation"
        >
          <FaBars className="text-lg" />
        </button>
        <div className="min-w-0 text-right">
          <p className="text-sm font-semibold text-gray-900">ATraq Portal</p>
          <p className="text-xs text-gray-500">Navigation</p>
        </div>
      </div>

      <div className="flex flex-1 min-h-0 overflow-hidden md:min-h-0">
        <Sidebar />
        <Sidebar
          isMobile
          isMobileOpen={isMobileSidebarOpen}
          onClose={() => setIsMobileSidebarOpen(false)}
        />

        {isMobileSidebarOpen && (
          <button
            type="button"
            className="fixed inset-0 z-40 bg-black/40 md:hidden"
            aria-label="Close navigation overlay"
            onClick={() => setIsMobileSidebarOpen(false)}
          />
        )}

        <main className="min-w-0 flex-1 overflow-y-auto overflow-x-auto bg-gray-100 p-2 sm:p-4">
          {children}
        </main>
      </div>
    </div>
  ) : (
    <Navigate to="/" />
  );
};

export default ProtectedRoute;
